import React from 'react';
const testimonials = [{
  text: 'Antes perdía una hora por día buscando datos de pacientes. Ahora todo está en un lugar. No lo puedo creer.',
  author: 'Dra. Valeria M.',
  location: 'Buenos Aires'
}, {
  text: 'El control de vacunación me salvó de varios problemas legales. Profesional y completo.',
  author: 'Dr. Sebastián R.',
  location: 'Córdoba'
}, {
  text: 'Lo bajé un viernes, el lunes ya lo tenía funcionando en la clínica. Facilísimo de usar.',
  author: 'Dra. Romina T.',
  location: 'Rosario'
}];
export function Testimonials() {
  return <section className="bg-white py-12 px-6" data-id="element-271">
      <div className="max-w-md mx-auto space-y-6" data-id="element-272">
        <h2 className="text-2xl font-bold text-navy text-center" data-id="element-273">
          Lo que dicen quienes ya lo usan
        </h2>

        <div className="space-y-4" data-id="element-274">
          {testimonials.map((testimonial, index) => <div key={index} className="bg-mint border border-teal/20 rounded-xl p-6 space-y-3" data-id="element-275">
              <div className="text-gold text-lg" data-id="element-276">🌟🌟🌟🌟🌟</div>
              <p className="text-navy text-[15px] leading-relaxed" data-id="element-277">
                "{testimonial.text}"
              </p>
              <p className="text-navy/60 text-sm font-medium" data-id="element-278">
                — {testimonial.author} · {testimonial.location}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}